<alliance-clubs-posts-sorting
  class="santa-flex santa-mb-20"
  [class.santa-mx-20]="!state?.isMobileScreen"
  (OutSelectedSorting)="setSorting($event ?? null)"
  [InpSelectedSorting]="state?.sorting ?? defaultSorting"
  *ngIf="state?.firstPostsWithSortingLoaded && state?.withSorting"
></alliance-clubs-posts-sorting>

<div class="santa-h-full santa-overflow-y-auto santa-box-border santa-flex santa-flex-col santa-w-full" allianceInfiniteScrolling [offset]="1000" [debounceTime]="100" (scrollPosition)="loadMore()">
  <santa-skeleton-loader
    [loading]="!state.posts"
    [empty]="!state.posts"
    [class.santa-pl-10]="!state.posts && !state?.isMobileScreen"
    [class.santa-mr-10]="!state.posts && !state?.isMobileScreen"
    [class.santa-mt-40]="!state.posts && state?.withCount"
    [showProgressBar]="false"
    [skeleton]="state?.isMobileScreen ? SkeletonClubsPostsListMobile : SkeletonClubsPostsListDesktop"
    [skeletonWidth]="0"
  >
    <ng-template #content>
      <ng-container *ngIf="state.posts && state?.withCount">
        <p class="santa-typo-secondary santa-text-black-500 santa-mb-20 760:santa-mx-20">
          {{ translations.foundItems | translate: { amount: state?.postsCount } }}
        </p>
      </ng-container>

      <ng-container *ngIf="!state.posts?.length && state?.searchEmptyState">
        <alliance-clubs-posts-search-empty-state class="santa-flex 760:santa-mx-20 santa-mb-20"></alliance-clubs-posts-search-empty-state>
      </ng-container>

      <div class="santa-mb-20" *ngFor="let post of state.posts; trackBy: trackByFn">
        <a href="" [routerLink]="getPostPageRouterLink(post)">
          <ng-container *ngIf="state.isMobileScreen">
            <alliance-clubs-posts-card-mobile [post]="post"></alliance-clubs-posts-card-mobile>
          </ng-container>
          <ng-container *ngIf="!state.isMobileScreen">
            <alliance-clubs-posts-card-desktop class="santa-flex santa-flex-shrink-0" [post]="post" [ngClass]="state?.postCardClasses ?? ''"></alliance-clubs-posts-card-desktop>
          </ng-container>
        </a>
      </div>

      <!--   LOAD MORE SPINNER   -->
      <div class="spinner-loader" *ngIf="state?.loadMorePostsInProgress">
        <santa-spinner-loader [spinnerSize]="'large'"></santa-spinner-loader>
      </div>
    </ng-template>
  </santa-skeleton-loader>
</div>
